import { useCallback } from 'react';
import { Box } from '@cbhq/cds-web/layout';
import { TextHeadline } from '@cbhq/cds-web/typography';
import { ActionType, ComponentType } from '@cbhq/client-analytics';

import { useAnalytics } from '../../hooks/useAnalytics';
import { useSessionDelete } from '../../hooks/useSession';
import { useProfileMenuV2 } from '../../providers/ProfileMenuV2Provider';

import { ItemContainer } from './ItemContainer';
import { LogoutIcon } from './LogoutIcon';

type Props = {
  label: string;
  onPress: () => void;
};

export function SignOutAllAccountsButton({ label, onPress }: Props) {
  const { userSwitcherEnabled, otherProfiles } = useProfileMenuV2();
  const { logEvent } = useAnalytics();
  const deleteSession = useSessionDelete();

  const handleSignOutAllAccounts = useCallback(() => {
    logEvent(
      otherProfiles.length > 1 ? 'user_switcher_sign_out_all_accounts' : 'user_switcher_sign_out',
      {
        action: ActionType.click,
        componentType: ComponentType.button,
        actionType: 'sign_out_all_accounts',
      },
    );

    void deleteSession();
    onPress();
  }, [deleteSession, logEvent, onPress, otherProfiles.length]);

  if (!userSwitcherEnabled) return null;

  return (
    <ItemContainer
      handleOnClick={handleSignOutAllAccounts}
      testID="signout-all-accounts-action-item"
      accessibilityLabel={label}
    >
      <Box width="32px" height="32px" justifyContent="center" alignItems="center">
        <LogoutIcon />
      </Box>
      <TextHeadline as="p" color="fgNegative" display="block">
        {label}
      </TextHeadline>
    </ItemContainer>
  );
}
